<template>
  <div class="redirect-wrapper fade-in">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-lg-8">
          <div class="card redirect-card shadow-lg">
            <div class="card-body p-4 p-md-5">
              <div class="d-flex justify-content-between align-items-center mb-4">
                <div>
                  <p class="text-uppercase small text-muted mb-1">Pagamento InfinitePay</p>
                  <h2 class="mb-0">Estamos processando seu pedido</h2>
                </div>
                <span class="badge bg-dark text-warning">Order NSU: {{ orderNsu }}</span>
              </div>

              <div v-if="status === 'paid'" class="alert alert-success d-flex align-items-center gap-2" role="alert">
                <i class="bi bi-check-circle-fill"></i>
                Pagamento confirmado! Sua conta será atualizada para Premium em instantes.
              </div>
              <div v-else class="alert alert-warning d-flex align-items-center gap-2" role="alert">
                <i class="bi bi-hourglass-split"></i>
                Assim que o pagamento for confirmado, liberaremos o plano Premium automaticamente.
              </div>

              <p class="text-muted">
                Você será notificado aqui quando o status mudar. Caso tenha fechado o navegador, pode retornar a qualquer
                momento usando este mesmo link.
              </p>

              <div class="d-flex flex-wrap gap-3 align-items-center mt-4">
                <button class="btn btn-vampire" type="button" @click="$emit('back')">
                  <i class="bi bi-arrow-left me-2"></i>
                  Voltar ao início
                </button>
                <button v-if="isLoggedIn" class="btn btn-outline-light" type="button" @click="$emit('back-to-profile')">
                  <i class="bi bi-person-circle me-2"></i>
                  Ir para meu perfil
                </button>
                <button v-else class="btn btn-outline-light" type="button" @click="$emit('login')">
                  <i class="bi bi-box-arrow-in-right me-2"></i>
                  Entrar para acompanhar
                </button>
              </div>

              <div class="mt-4">
                <p class="text-muted small mb-2">Atualizações automáticas</p>
                <div class="progress" role="progressbar" aria-label="Progresso do pagamento" :aria-valuenow="progressPercent"
                  aria-valuemin="0" aria-valuemax="100">
                  <div class="progress-bar progress-bar-striped progress-bar-animated" :style="{ width: `${progressPercent}%` }">
                  </div>
                </div>
                <p class="text-muted small mt-2 mb-0">
                  Última verificação: {{ lastChecked || 'aguardando' }} — Status: {{ statusLabel }}
                </p>
                <p v-if="error" class="text-danger small mt-2 mb-0">{{ error }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from '../services/api'

const STATUS_LABELS = {
  paid: 'Pagamento confirmado',
  partial: 'Pagamento parcial',
  pending: 'Aguardando pagamento',
  pending_payment: 'Aguardando pagamento',
  link_created: 'Aguardando pagamento'
}

export default {
  name: 'PaymentRedirectView',
  props: {
    orderNsu: {
      type: String,
      required: true
    },
    isLoggedIn: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      status: 'pending_payment',
      error: '',
      lastChecked: '',
      progressPercent: 10,
      pollingTimer: null
    }
  },
  computed: {
    statusLabel() {
      return STATUS_LABELS[this.status] || this.status
    }
  },
  mounted() {
    this.fetchStatus()
  },
  beforeUnmount() {
    if (this.pollingTimer) {
      clearTimeout(this.pollingTimer)
    }
  },
  methods: {
    scheduleNextPoll() {
      if (this.status === 'paid') {
        return
      }

      this.pollingTimer = setTimeout(() => {
        this.fetchStatus()
      }, 5000)
    },
    async fetchStatus() {
      if (!this.orderNsu) {
        this.error = 'Pedido não identificado.'
        return
      }

      this.error = ''
      try {
        const { data } = await api.get('/membership/status', {
          params: { order_nsu: this.orderNsu }
        })
        this.status = data.status || 'pending_payment'
        this.progressPercent = this.status === 'paid' ? 100 : Math.min(this.progressPercent + 15, 90)
        this.lastChecked = new Date().toLocaleTimeString()
        this.$emit('status-updated', this.status)
      } catch (error) {
        this.error = error.response?.data?.error || 'Não foi possível verificar o status do pagamento.'
      } finally {
        this.scheduleNextPoll()
      }
    }
  }
}
</script>

<style scoped>
.redirect-wrapper {
  padding: 2rem 0 3rem;
}

.redirect-card {
  background: rgba(17, 17, 17, 0.94);
  border: 1px solid rgba(212, 175, 55, 0.3);
  border-radius: 24px;
  color: #f8f9fa;
}

.btn-vampire {
  background: var(--vampire-red);
  color: #f8f9fa;
  border: none;
}

.btn-vampire:hover {
  background: var(--vampire-blood);
}

.progress {
  background: rgba(255, 255, 255, 0.1);
  height: 8px;
}

.progress-bar {
  background-color: var(--vampire-gold);
}
</style>
